'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTracking = require('react-tracking');

var _reactTracking2 = _interopRequireDefault(_reactTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Insert this component near the top of any new page with the respective pageName, to track the page load event.
var TrackPageLoad = function (_React$PureComponent) {
  _inherits(TrackPageLoad, _React$PureComponent);

  function TrackPageLoad() {
    _classCallCheck(this, TrackPageLoad);

    return _possibleConstructorReturn(this, (TrackPageLoad.__proto__ || Object.getPrototypeOf(TrackPageLoad)).apply(this, arguments));
  }

  _createClass(TrackPageLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.pageName) {
        console.warn('No page name defined in props');
        return null;
      }
      try {
        this.props.tracking.trackEvent({ page: this.props.pageName, subPage: this.props.subPageName });
      } catch (err) {
        console.log('error: ' + err);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return TrackPageLoad;
}(_react2.default.PureComponent);

TrackPageLoad.propTypes = {
  pageName: _propTypes2.default.string.isRequired,
  subPageName: _propTypes2.default.string
};

exports.default = (0, _reactTracking2.default)()(TrackPageLoad);


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/TrackPageLoad.js
// module id = 985
// module chunks = 48 49 50